<template>
  <div class="form-container editform-container">
    <h1><span>防獣害対策</span>
	<span class="color">
		（{{ typeMapping[wildlifeData.type] }}）
	</span>
	</h1>
    <table v-if="wildlifeData" class="wildlife-list-detail-table">
      <tbody>
        <tr>
          <td class="title">受付番号</td>
          <td class="text">： {{ wildlifeData.no }}</td>
        </tr>
        <tr>
          <td class="title">利用者</td>
          <td class="text">： {{ wildlifeData.id }}
          {{ wildlifeData.nameKanji }}</td>
        </tr>
	  </tbody>

	  <tbody v-if="isTrapType">
        <tr>
          <td class="title">設置場所</td>
          <td class="text">： {{ wildlifeData.municipalities }}
          </td>
        </tr>
        <tr>
          <td class="title"></td>
          <td class="text">　 {{ wildlifeData.strAdd }}
          </td>
        </tr>
        <tr>
          <td class="title">日時</td>
          <td class="text">： {{
			formatDate(wildlifeData.damageDate, wildlifeData.type) }}
		  </td>
        </tr>
        <tr>
          <td class="title">わなの種類</td>
          <td class="text">：  {{
			trapTypeMapping[wildlifeData.trapType] }}</td>
		</tr>
        <tr>
          <td class="title">わなの幅(cm)</td>
          <td class="text">： {{ wildlifeData.trapWidth }}</td>
        </tr>
        <tr>
          <td class="title">わなの高さ(cm)</td>
          <td class="text">： {{ wildlifeData.trapHeight }}</td>
		</tr>
        <tr>
          <td class="title">わなの奥行(cm)</td>
          <td class="text">： {{ wildlifeData.trapDepth }}</td>
        </tr>
        <tr>
          <td class="title">獣種</td>
          <td class="text">： {{
			animalTypeMapping[wildlifeData.animalType] }}</td>
		</tr>
	  </tbody>

	  <tbody v-if="isFenceType">
        <tr>
          <td class="title">名称</td>
          <td class="text">： {{ wildlifeData.fenceName }}
          </td>
        </tr>
		<tr>
          <td class="title">日付</td>
          <td class="text">： {{ 
			formatDate(wildlifeData.fenceInstDate, wildlifeData.type) }}
		  </td>
		</tr>
		<tr>
          <td class="title"></td>
          <td class="text">～ {{ 
			 formatDate(wildlifeData.fenceRemoDate, wildlifeData.type) }}
		  </td>
        </tr>
        <tr>
          <td class="title">柵の種類</td>
          <td class="text">： {{
			fenceTypeMapping[wildlifeData.fenceType] }}</td>
		</tr>
        <tr>
          <td class="title">柵の総延長(km)</td>
          <td class="text">： {{ wildlifeData.fenceLength }}</td>
        </tr>
	  </tbody>

	  <tbody>
        <!-- 画像データ -->
		<tr>
          <td class="title">画像</td>
          <td>： 
                <img :src="wildlifeData.imageUrl" class="thumb"
				@click="imageUp(wildlifeData.imageUrl)" />
				　
                <img :src="wildlifeData.imageUrl1" class="thumb"
				@click="imageUp(wildlifeData.imageUrl1)" />
				　
                <img :src="wildlifeData.imageUrl2" class="thumb"
				@click="imageUp(wildlifeData.imageUrl2)" />
          </td>
		</tr>

        <tr v-if="isFenceType">
          <td class="title">追記事項</td>
          <td class="text">： {{ wildlifeData.fencememo }}</td>
		</tr>
        <tr v-if="isTrapType">
          <td class="title">備考</td>
          <td class="text">： {{ wildlifeData.addNote }}</td>
        </tr>

        <tr>
          <td class="title">緯度</td>
          <td class="text">： {{ wildlifeData.locationLat || '不明' }}
		  </td>
        </tr>
        <tr>
          <td class="title">経度</td>
          <td class="text">　 {{ wildlifeData.locationLon || '不明' }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="c-detail-button-group">
    <button @click="goBack" class="second">戻る</button>
    <button @click="editRecord" class="usual" :class="{ disabled: this.tonDisabeld }" v-bind:disabled="this.editButtonDisabeld">編集</button>
    </div>
  </div>
	<!-- ポップアップ -->
	<div class="popup" v-if="popup_on">
    	<img :src="popup_src" @click="imageDown" class="big" />
    </div>
</template>

<script>
import "@/assets/styles/Wildlife-detail-table.css";
export default {
  data() {
    return {
      wildlifeData: {},
      directAdminAgency: '',
      section: '',
      editButtonDisabeld: true,
      isTrapType: false,
      isFenceType: false,
	  popup_on: false,
	  popup_src: '',
      typeMapping: {
        "5": "わな",
        "6": "柵"
      },
      animalTypeMapping: {
        "01": "イノシシ",
        "02": "ニホンジカ",
        "03": "クマ",
        "04": "サル",
        "05": "タヌキ",
        "06": "アナグマ",
        "07": "ハクビシン",
        "08": "アライグマ",
        "09": "ヌートリア",
        "10": "鳥類",
        "11": "その他"
      },
      juvenileTypeMapping: {
        "2" : "幼獣", 
        "1" : "成獣", 
        "3" : "幼獣と成獣", 
        "4" : "不明"
      },
      trapTypeMapping: {
        "1" : "箱わな",
        "2" : "囲いわな",
        "3" : "くくりわな",
        "4" : "箱落とし",
        "5" : "その他"
      },
      fenceTypeMapping: {
        "1": "電気",
        "2": "金属",
        "3": "ネット",
        "4": "ワイヤーメッシュ",
        //"5": "複合",
        "9": "その他",
      },
    };
  },
  created() {
	try {
      if (this.$route.query.data)
      	this.wildlifeData =
      		JSON.parse(decodeURIComponent(this.$route.query.data))[0];
	} catch(e) {
		alert(e);
	}
  },
  mounted() {
	try {
    console.log("Received wildlifeData:", this.wildlifeData);
    this.section = localStorage.getItem("section");
    this.directAdminAgency = localStorage.getItem("directAdminAgency");
    const userId = localStorage.getItem("userId");

    // 「種別」が「わな」か「柵」かによって表示フラグを設定
    if (this.wildlifeData && this.wildlifeData.type === '5') {
      this.isTrapType = true;
    } else if (this.wildlifeData && this.wildlifeData.type === '6') {
      this.isFenceType = true;
    }

    if (this.wildlifeData.id) {
      this.getNameById(this.wildlifeData.id).then((name) => {
        this.wildlifeData.name = name;
      });
    }
    
    if (this.section === '0000') {
      // システム管理者は変更可能
      this.editButtonDisabeld = false;
    //} else if (this.section === '0100' || this.section === '0101' || this.section === '0210') {
    } else if (this.section === '0100' || this.section === '0101') {
      // 行政機関管理者、行政機関メンバー、見える化管理者は変更可能
	  // 直属行政機関だけ職員が修正可能 2026/04/24 RFJ R.Komatsu
	  // 見える化管理者がメンバーのデータ修正するには再設計が必要
   	  if (this.wildlifeData.directAdminAgency == this.directAdminAgency)
      	this.editButtonDisabeld = false;
    } else {
      // それ以外は自分の登録されたデータだけが変更可能
      if (this.wildlifeData.id === userId) {
        this.editButtonDisabeld = false;
      }
    }
	} catch (e) {
		alert(e);
	}
  },
  methods: {
	imageDown() {
		this.popup_on = false;
	},
	imageUp(src) {
		if (this.popup_src != src) {
			this.popup_src = src;
			this.popup_on = true;
		} else {
			this.popup_on = !this.popup_on;
		}
	},
    formatDate(dateStr, type) {
	  if (!dateStr) return;
      // UTC日時から日本時間に変換
      const date = new Date(dateStr);

      // 日付が無効な場合の処理
      if (isNaN(date.getTime())) {
        return '不明'; // 無効な日付の場合の表示
      }

      // JST (UTC + 9時間)に変換
      if (type==5)
      date.setHours(date.getHours() + 9);

      // フォーマット: yyyy年MM月dd日 hh:mm
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      if (type==5)
      return `${year}年${month}月${day}日 ${hours}:${minutes}`;
	  else
      return `${year}年${month}月${day}日`;
    },
    async getNameById(id) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/WildlifeCounterPlan/getList/${id}`,
          {},
          {
            headers: {
                Authorization: `Bearer ${token}`,
            }
          },
        );            
      console.log("Fetched Items:", this.items);
        if (response.status === 200 && response.data.message === "取得成功") {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          this.items = response.data.data;

          this.filteredItems = [...this.items];
          // 都道府県のリストを取得
          this.cities = ["未選択", ...new Set(this.items.map(item => item.municipalities ? item.municipalities.prefecture : '未設定'))];
  
        } else {
          console.warn("データが配列ではありません:", response.data);
          this.items = [];
          this.filteredItems = [];
        }
      } catch (error) {
        console.log(error);
        this.items = [];
        this.filteredItems = [];
      }
    },
    goBack() {
      // ヒストリーに基づいて戻る
      this.$router.go(-1);

      // 状況に応じて、以下を補足的に入れることで確認可能
      const query = this.$route.query;
      console.log("Returning with query:", query);
    },
    editRecord() {
      this.$router.push({ name: 'MeasureEdit', // 編集画面のルートパス
      query: { data: encodeURIComponent(JSON.stringify(this.wildlifeData)) }
      });
    }
  }
};
</script>

<style scoped>
.c-detail-button-group {
  display: flex;
  justify-content: center; /* ボタンを中央に配置 */
  margin-top: 20px; /* 上部余白を広げる */
}
.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
.title { font-weight: bold }
.color { color: green; }
.text { color: black; }
.thumb { max-width: 100px; cursor: zoom-in; }
.big { max-width: 300px; cursor: zoom-out; }
.popup {
  width:600px;
  height:auto;
  display: block;
  position: fixed;
  top: 15%;
  left: 70%;
  transform:translate(-50%);
  text-align: right;
}
</style>
